import { useState } from "react";
import { useTranslation } from "react-i18next";

const PaymentMethodCheckbox = ({parentData, paymentMethodList, sendMethodDataFromChild}) => {
    const { t } = useTranslation();
    const [selectedIds, setSelectedIds] = useState(parentData.length > 1 ? parentData.split(",") : []);

    const handlePaymentCheckboxChange = (event) => {
        const checkedId = event.target.value;
        let method = [];
        if (event.target.checked){
            setSelectedIds([...selectedIds,checkedId])
            method = [...selectedIds,checkedId];
        } else {
            setSelectedIds(selectedIds.filter(id=>id !== checkedId))
            method = selectedIds.filter(id=>id !== checkedId)
        }
        sendMethodDataFromChild(method);
    }

    return (
        <div>
            <label className="font-medium capitalize text-sm sm:text-base">{ t('payment')}</label>
            <div>
                {paymentMethodList.map((method, index) => (
                    <div key={index} className="flex items-center my-2">
                        <label className="relative flex items-center cursor-pointer">
                            <input type="checkbox" name={method.name} value={method.id} defaultChecked={parentData.includes(method.id) ? true : false} onChange={(event) => { handlePaymentCheckboxChange(event) }}className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                            <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                </svg>
                            </span>
                        </label>
                        <div className="font-normal text-xs sm:text-base ml-2 text-light-400 capitalize">{ t(method.name.toLowerCase())}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default PaymentMethodCheckbox;